<template>
  <div class="detail-container">
    <div class="sidebar">
      <div class="sidebar-title">排序 & 筛选</div>
      <el-select v-model="sortType" placeholder="排序方式" class="sidebar-select">
        <el-option label="错误次数" value="wrongCount" />
        <el-option label="时间" value="time" />
      </el-select>

      <!-- 时间筛选 -->
      <div class="filter-section">
        <div class="filter-title">时间筛选</div>
        <el-select v-model="timeFilter" placeholder="选择时间范围" class="sidebar-select">
          <el-option label="全部时间" value="all" />
          <el-option label="近一周" value="week" />
          <el-option label="近一月" value="month" />
          <el-option label="近三月" value="quarter" />
          <el-option label="近半年" value="halfYear" />
          <el-option label="近一年" value="year" />
        </el-select>
      </div>

      <!-- 可扩展更多筛选条件 -->
    </div>
    <div class="main-content">
       <!-- 批量操作工具栏 -->
       <div class="batch-toolbar" v-if="filteredQuestions.length > 0">
         <div class="batch-info">
           <el-checkbox
             v-model="selectAll"
             @change="handleSelectAllChange"
             :indeterminate="isIndeterminate"
           >
             全选
           </el-checkbox>
           <span class="selected-count" v-if="selectedQuestions.length > 0">
             已选择 {{ selectedQuestions.length }} 道题
           </span>
         </div>
         <div class="batch-actions" v-if="selectedQuestions.length > 0">
           <el-button
             type="primary"
             size="small"
             @click="openBatchRedoDialog"
             :disabled="selectedQuestions.length === 0"
           >
             批量重做 ({{ selectedQuestions.length }})
           </el-button>
           <el-button
             type="danger"
             size="small"
             @click="batchDeleteQuestions"
             :disabled="selectedQuestions.length === 0"
           >
             批量删除 ({{ selectedQuestions.length }})
           </el-button>
         </div>
       </div>

      <div class="question-list">
        <div v-for="item in filteredQuestions" :key="item.id" class="question-row">
           <div class="question-checkbox">
             <el-checkbox
               v-model="item.selected"
               @change="handleQuestionSelect"
             />
           </div>
          <div class="question-content">
            <div class="question-title">错题</div>
            <div class="question-body">{{ item.content }}</div>
                         <div class="question-actions">
               <el-button
                 type="primary"
                 size="small"
                 @click="openRedoDialog(item)"
                 class="redo-btn"
               >
                 重做
               </el-button>
               <el-button
                 type="danger"
                 size="small"
                 @click="deleteQuestion(item)"
                 class="delete-btn"
               >
                 删除
               </el-button>
             </div>
          </div>
          <div class="question-reason">
            <div class="reason-title">原因</div>
            <div class="reason-body">{{ item.analysis }}</div>
             <div class="question-time">
               <span class="time-label">加入时间：</span>
               <span class="time-value">{{ formatTime(item.createTime) }}</span>
             </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 重做对话框 -->
    <el-dialog
      title="重做错题"
      :visible.sync="redoDialogVisible"
      width="600px"
      :before-close="handleCloseRedoDialog"
    >
      <div class="redo-content">
        <div class="question-display">
          <h4>题目内容：</h4>
          <p>{{ currentQuestion.content }}</p>
        </div>

        <div class="upload-section">
          <h4>上传答案图片：</h4>
          <file-upload
            v-model="answerImageUrl"
            accept="image/*"
            tips="请上传清晰的答案图片"
            list-type="picture"
          />
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseRedoDialog">取消</el-button>
        <el-button
          type="primary"
          @click="submitAnswer"
          :loading="judging"
          :disabled="!answerImageUrl"
        >
          {{ judging ? '判断中...' : '提交答案' }}
        </el-button>
      </div>
    </el-dialog>

         <!-- 批量重做对话框 -->
     <el-dialog
       title="批量重做错题"
       :visible.sync="batchRedoDialogVisible"
       width="800px"
       :before-close="handleCloseBatchRedoDialog"
     >
       <div class="batch-redo-content">
         <div class="selected-questions">
           <h4>已选择的题目：</h4>
           <div class="question-list-mini">
             <div
               v-for="(question, index) in selectedQuestions"
               :key="question.id"
               class="question-item-mini"
             >
               <span class="question-number">{{ index + 1 }}.</span>
               <span class="question-content-mini">{{ question.content }}</span>
             </div>
           </div>
         </div>

         <div class="upload-section">
           <h4>上传答案图片：</h4>
           <p class="upload-tips">请为每道题上传对应的答案图片，图片命名格式：题号_答案.jpg</p>

           <!-- 上传状态指示器 -->
           <div class="upload-status" v-if="selectedQuestions.length > 0">
             <el-alert
               :title="`已选择 ${selectedQuestions.length} 道题，已上传 ${batchAnswerImages.length} 张图片`"
               :type="batchAnswerImages.length === selectedQuestions.length ? 'success' : 'info'"
               :closable="false"
               show-icon
             >
               <template slot="title">
                 <span v-if="batchAnswerImages.length === selectedQuestions.length">
                   ✅ 图片数量匹配，可以提交
                 </span>
                 <span v-else>
                   ⏳ 请继续上传图片 ({{ batchAnswerImages.length }}/{{ selectedQuestions.length }})
                 </span>
               </template>
             </el-alert>
           </div>

           <el-upload
             class="upload-demo"
             drag
             action="#"
             :auto-upload="false"
             :on-change="handleBatchFileChange"
             :on-remove="handleBatchFileRemove"
             :file-list="batchFileList"
             multiple
             :limit="selectedQuestions.length"
             accept="image/*"
             list-type="picture"
           >
             <i class="el-icon-upload"></i>
             <div class="el-upload__text">将答案图片拖到此处，或<em>点击上传</em></div>
             <div class="el-upload__tip" slot="tip">请为每道题上传对应的答案图片</div>
           </el-upload>
         </div>
       </div>

       <div slot="footer" class="dialog-footer">
         <el-button @click="handleCloseBatchRedoDialog">取消</el-button>
         <el-button
           type="primary"
           @click="submitBatchAnswers"
           :loading="batchJudging"
           :disabled="!canSubmitBatchAnswers"
         >
           {{ batchJudging ? '判断中...' : '提交所有答案' }}
         </el-button>
       </div>
     </el-dialog>

     <!-- 判断结果对话框 -->
     <el-dialog
       title="判断结果"
       :visible.sync="resultDialogVisible"
       width="500px"
     >
       <div class="result-content">
         <div class="result-icon">
           <i :class="resultIcon" :style="{ color: resultColor }"></i>
         </div>
         <div class="result-text">
           <h3 :style="{ color: resultColor }">{{ resultTitle }}</h3>
           <p>{{ resultMessage }}</p>
         </div>
       </div>

       <div slot="footer" class="dialog-footer">
         <el-button @click="resultDialogVisible = false">确定</el-button>
         <el-button
           v-if="batchResults.length > 0"
           type="info"
           @click="showDetailedResults"
         >
           查看详情
         </el-button>
       </div>
     </el-dialog>

     <!-- 详细结果对话框 -->
     <el-dialog
       title="详细判断结果"
       :visible.sync="detailedResultsVisible"
       width="1000px"
       :before-close="handleCloseDetailedResults"
     >
       <div class="detailed-results-content">
         <el-table :data="batchResults" style="width: 100%" border>
           <el-table-column prop="index" label="题号" width="80" align="center">
             <template slot-scope="scope">
               <span class="question-number-badge">第{{ scope.$index + 1 }}题</span>
             </template>
           </el-table-column>

           <el-table-column prop="question.content" label="题目内容" min-width="200">
             <template slot-scope="scope">
               <div class="question-content-cell">
                 {{ scope.row.question.content }}
               </div>
             </template>
           </el-table-column>

           <el-table-column prop="success" label="判断状态" width="120" align="center">
             <template slot-scope="scope">
               <div v-if="scope.row.success && scope.row.result" class="status-success">
                 <i class="el-icon-success"></i>
                 <span>判断成功</span>
               </div>
               <div v-else class="status-error">
                 <i class="el-icon-error"></i>
                 <span>判断失败</span>
               </div>
             </template>
           </el-table-column>

           <el-table-column prop="result" label="判断结果" min-width="300">
             <template slot-scope="scope">
               <div v-if="scope.row.success && scope.row.result">
                 <div class="result-summary">
                   <div class="result-row">
                     <span class="result-label">结果：</span>
                     <span class="result-value">
                       <span :class="getJudgeClass(scope.row.result)">{{ getJudgeText(scope.row.result) }}</span>
                     </span>
                   </div>
                   <div class="result-row">
                     <span class="result-label">分析：</span>
                     <span class="result-value">{{ getComment(scope.row.result) || '无' }}</span>
                   </div>
                   <div class="result-row">
                     <span class="result-label">作答：</span>
                     <span class="result-value">{{ getCorrectAnswer(scope.row.result) || '无' }}</span>
                   </div>
                 </div>
               </div>
               <div v-else class="error-display">
                 <span class="error-text">{{ scope.row.error || '判断失败' }}</span>
               </div>
             </template>
           </el-table-column>
         </el-table>

         <!-- 原始数据对话框 -->

       </div>

       <div slot="footer" class="dialog-footer">
         <el-button @click="handleCloseDetailedResults">关闭</el-button>
       </div>
     </el-dialog>
  </div>
</template>

<script>
import { getStudentWrongQuestions, deleteWrongQuestion } from '@/api/userbook'
import { judgeQuestion } from '@/api/homework'
import { getToken } from '@/utils/auth'
import { parseJwt } from '@/utils/jwtUtils'
import FileUpload from '@/components/FileUpload'

export default {
  name: 'UserbookSubjectDetail',
  components: {
    FileUpload
  },
  data() {
    return {
       sortType: 'wrongCount',
       timeFilter: 'all',
      questions: [],
      subjectName: '',
       // 重做相关
       redoDialogVisible: false,
       resultDialogVisible: false,
       detailedResultsVisible: false,
       currentQuestion: {},
       answerImageUrl: '',
       judging: false,
       // 结果相关
       resultIcon: '',
       resultColor: '',
       resultTitle: '',
       resultMessage: '',
       // 批量操作相关
       selectAll: false,
       isIndeterminate: false,
       batchRedoDialogVisible: false,
       batchAnswerImages: [],
       batchJudging: false,
       batchFileList: [],
       batchResults: [],
       rawDataVisible: false,
       currentRawData: null
    }
  },
  computed: {
    filteredQuestions() {
      let filtered = this.questions.filter(q => q.suboptions === this.subjectName)

      // 时间筛选
      if (this.timeFilter !== 'all') {
        const now = new Date()
        let startDate = new Date()

        switch (this.timeFilter) {
          case 'week':
            startDate.setDate(now.getDate() - 7)
            break
          case 'month':
            startDate.setMonth(now.getMonth() - 1)
            break
          case 'quarter':
            startDate.setMonth(now.getMonth() - 3)
            break
          case 'halfYear':
            startDate.setMonth(now.getMonth() - 6)
            break
          case 'year':
            startDate.setFullYear(now.getFullYear() - 1)
            break
        }

        filtered = filtered.filter(q => {
          if (q.createTime) {
            const questionDate = new Date(q.createTime)
            return questionDate >= startDate && questionDate <= now
          }
          return true // 如果没有时间信息，默认显示
        })
      }

      // 排序
      if (this.sortType === 'time') {
        filtered.sort((a, b) => {
          const dateA = a.createTime ? new Date(a.createTime) : new Date(0)
          const dateB = b.createTime ? new Date(b.createTime) : new Date(0)
          return dateB - dateA // 最新的在前
        })
      } else if (this.sortType === 'wrongCount') {
        // 按错误次数排序（使用wrongCount字段）
        filtered.sort((a, b) => {
          const wrongCountA = a.wrongCount || 0
          const wrongCountB = b.wrongCount || 0
          return wrongCountB - wrongCountA // 错误次数多的在前
        })
      }

             return filtered
     },

     // 已选择的错题
     selectedQuestions() {
       return this.filteredQuestions.filter(q => q.selected)
     },

     // 检查是否可以提交批量答案
     canSubmitBatchAnswers() {
       return this.batchAnswerImages.length > 0 &&
              this.batchAnswerImages.length === this.selectedQuestions.length &&
              this.batchAnswerImages.every(img => img instanceof File)
     }
   },
  watch: {
    batchAnswerImages: {
      handler(newVal) {
        console.log('batchAnswerImages changed:', newVal)
      },
      deep: true
    }
  },
  async created() {
    this.subjectName = this.$route.params.subject
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      const token = getToken()
      const userInfo = parseJwt(token)
      const userObj = JSON.parse(userInfo.userInfo)
      const userId = userObj.id
      const res = await getStudentWrongQuestions(userId)
       // 为每个错题添加selected属性
       this.questions = (res.data || []).map(q => ({ ...q, selected: false }))
     },

    // 打开重做对话框
    openRedoDialog(question) {
      this.currentQuestion = question
      this.answerImageUrl = ''
      this.redoDialogVisible = true
    },

    // 关闭重做对话框
    handleCloseRedoDialog() {
      this.redoDialogVisible = false
      this.answerImageUrl = ''
      this.currentQuestion = {}
    },

    // 提交答案进行判断
    async submitAnswer() {
      if (!this.answerImageUrl) {
        this.$message.warning('请先上传答案图片')
        return
      }

      this.judging = true
      try {
        // 构建questions参数
        const questions = {
          question_list: [{
            stems: this.currentQuestion.content || this.currentQuestion.stem || '',
            answer: this.currentQuestion.answer || ''
          }]
        };

        // 调用判断接口 - 使用正确的参数格式
        const response = await judgeQuestion(this.answerImageUrl, questions)

        this.judging = false

        if (response.code === 1) {
          // 判断成功
          const result = response.data
          this.showResult(result)
        } else {
          this.$message.error(response.msg || '判断失败，请重试')
        }
      } catch (error) {
        this.judging = false
        console.error('判断答案时出错:', error)
        this.$message.error('判断失败，请重试')
      }
    },

         // 显示判断结果
     showResult(result) {
       if (result.is_correct) {
         this.resultIcon = 'el-icon-success'
         this.resultColor = '#67C23A'
         this.resultTitle = '回答正确！'
         this.resultMessage = '恭喜你，答案是正确的！'
       } else {
         this.resultIcon = 'el-icon-error'
         this.resultColor = '#F56C6C'
         this.resultTitle = '回答错误'
         this.resultMessage = `正确答案是：${result.correct_answer || '暂无'}`
       }

       this.resultDialogVisible = true
       this.redoDialogVisible = false
     },

     // 格式化时间显示
     formatTime(timeString) {
       if (!timeString) return '未知时间'

       try {
         const date = new Date(timeString)
         if (isNaN(date.getTime())) return '时间格式错误'

         const year = date.getFullYear()
         const month = String(date.getMonth() + 1).padStart(2, '0')
         const day = String(date.getDate()).padStart(2, '0')
         const hours = String(date.getHours()).padStart(2, '0')
         const minutes = String(date.getMinutes()).padStart(2, '0')

         return `${year}-${month}-${day} ${hours}:${minutes}`
       } catch (error) {
         return '时间格式错误'
       }
     },

     // 删除错题
     async deleteQuestion(question) {
       try {
         await this.$confirm(
           `确定要删除这道错题吗？\n\n题目：${question.content.substring(0, 50)}${question.content.length > 50 ? '...' : ''}`,
           '确认删除',
           {
             confirmButtonText: '确定删除',
             cancelButtonText: '取消',
             type: 'warning',
             dangerouslyUseHTMLString: false
           }
         )

         // 调用删除API
         const response = await deleteWrongQuestion(question.id)

         if (response.code === 1) {
           this.$message.success('删除成功')
           // 从本地数据中移除已删除的错题
           this.questions = this.questions.filter(q => q.id !== question.id)
         } else {
           this.$message.error(response.msg || '删除失败')
         }
       } catch (error) {
         if (error === 'cancel') {
           // 用户取消删除
           return
         }
         console.error('删除错题时出错:', error)
         this.$message.error('删除失败，请重试')
       }
     },

     // 处理全选变化
     handleSelectAllChange(val) {
       this.filteredQuestions.forEach(q => {
         q.selected = val
       })
       this.isIndeterminate = false
     },

     // 处理单个题目选择
     handleQuestionSelect() {
       const selectedCount = this.selectedQuestions.length
       const totalCount = this.filteredQuestions.length

       this.selectAll = selectedCount === totalCount
       this.isIndeterminate = selectedCount > 0 && selectedCount < totalCount
     },

     // 打开批量重做对话框
     openBatchRedoDialog() {
       if (this.selectedQuestions.length === 0) {
         this.$message.warning('请先选择要重做的错题')
         return
       }
       console.log('=== 打开批量重做对话框 ===')
       console.log('选中题目数量:', this.selectedQuestions.length)
       console.log('选中的题目:', this.selectedQuestions.map(q => ({ id: q.id, content: q.content.substring(0, 30) + '...' })))

       // 清空之前的数据
       this.batchAnswerImages = []
       this.batchFileList = []
       console.log('清空后的数据状态:')
       console.log('- batchAnswerImages:', this.batchAnswerImages)
       console.log('- batchFileList:', this.batchFileList)

       this.batchRedoDialogVisible = true
     },

     // 关闭批量重做对话框
     handleCloseBatchRedoDialog() {
       this.batchRedoDialogVisible = false
       this.batchAnswerImages = []
       this.batchFileList = []
     },

     // 处理批量文件选择
     handleBatchFileChange(file, fileList) {
       console.log('文件选择变化:', file, fileList)
       this.batchFileList = fileList
       // 确保获取到原始文件对象
       this.batchAnswerImages = fileList.map(f => {
         const rawFile = f.raw || f
         console.log('处理文件:', f.name, '原始文件:', rawFile)
         return rawFile
       })
       console.log('更新后的 batchAnswerImages:', this.batchAnswerImages)
     },

     // 处理批量文件移除
     handleBatchFileRemove(file, fileList) {
       console.log('文件移除:', file, fileList)
       this.batchFileList = fileList
       // 确保获取到原始文件对象
       this.batchAnswerImages = fileList.map(f => {
         const rawFile = f.raw || f
         console.log('处理文件:', f.name, '原始文件:', rawFile)
         return rawFile
       })
       console.log('更新后的 batchAnswerImages:', this.batchAnswerImages)
     },

     // 批量删除错题
     async batchDeleteQuestions() {
       if (this.selectedQuestions.length === 0) {
         this.$message.warning('请先选择要删除的错题')
         return
       }

       try {
         const questionTitles = this.selectedQuestions.map(q =>
           q.content.substring(0, 30) + (q.content.length > 30 ? '...' : '')
         ).join('\n')

         await this.$confirm(
           `确定要删除选中的 ${this.selectedQuestions.length} 道错题吗？\n\n${questionTitles}`,
           '确认批量删除',
           {
             confirmButtonText: '确定删除',
             cancelButtonText: '取消',
             type: 'warning',
             dangerouslyUseHTMLString: false
           }
         )

         // 批量删除
         const deletePromises = this.selectedQuestions.map(q => deleteWrongQuestion(q.id))
         const responses = await Promise.all(deletePromises)

         // 检查删除结果
         const successCount = responses.filter(r => r.code === 1).length
         const failCount = responses.length - successCount

         if (failCount === 0) {
           this.$message.success(`成功删除 ${successCount} 道错题`)
         } else {
           this.$message.warning(`成功删除 ${successCount} 道错题，失败 ${failCount} 道`)
         }

         // 从本地数据中移除已删除的错题
         const deletedIds = this.selectedQuestions.map(q => q.id)
         this.questions = this.questions.filter(q => !deletedIds.includes(q.id))

         // 重置选择状态
         this.selectAll = false
         this.isIndeterminate = false
       } catch (error) {
         if (error === 'cancel') {
           return
         }
         console.error('批量删除错题时出错:', error)
         this.$message.error('批量删除失败，请重试')
       }
     },

     // 提交批量答案
     async submitBatchAnswers() {
       console.log('=== 开始提交批量答案 ===')
       console.log('当前图片数组:', this.batchAnswerImages)
       console.log('图片数组长度:', this.batchAnswerImages.length)
       console.log('选中的题目数量:', this.selectedQuestions.length)
       console.log('选中的题目:', this.selectedQuestions.map(q => ({ id: q.id, content: q.content.substring(0, 30) + '...' })))

       // 检查图片数组中的每个元素
       this.batchAnswerImages.forEach((img, index) => {
         console.log(`图片 ${index + 1}:`, {
           type: typeof img,
           isFile: img instanceof File,
           name: img.name || '无名称',
           size: img.size || '无大小信息'
         })
       })

       if (this.batchAnswerImages.length === 0) {
         this.$message.warning('请先上传答案图片')
         return
       }

       if (this.batchAnswerImages.length !== this.selectedQuestions.length) {
         this.$message.warning(`请为每道题上传对应的答案图片，当前上传了 ${this.batchAnswerImages.length} 张，需要 ${this.selectedQuestions.length} 张`)
         return
       }

       this.batchJudging = true
       try {
         // 为每道题提交答案进行判断
         const results = []
         for (let i = 0; i < this.selectedQuestions.length; i++) {
           const question = this.selectedQuestions[i]
           const answerImage = this.batchAnswerImages[i]

           console.log(`处理第${i + 1}题:`, question.content)
           console.log(`对应的图片:`, answerImage)

           if (!answerImage) {
             results.push({
               question: question,
               error: '缺少答案图片',
               success: false
             })
             continue
           }

           // 构建questions参数
           const questions = {
             question_list: [{
               stems: question.content || question.stem || '',
               answer: question.answer || ''
             }]
           };

           console.log('=== 批量判题参数构建详情 ===')
           console.log('题目ID:', question.id)
           console.log('题目内容:', question.content || question.stem)
           console.log('题目答案:', question.answer)
           console.log('答案图片对象:', answerImage)
           console.log('图片类型:', typeof answerImage)
           console.log('是否为File对象:', answerImage instanceof File)
           if (answerImage instanceof File) {
             console.log('文件名:', answerImage.name)
             console.log('文件大小:', answerImage.size)
             console.log('文件类型:', answerImage.type)
           }
           console.log('构建的questions参数:', questions)

           try {
             console.log(`=== 第${i + 1}题 API 调用 ===`)
             const response = await judgeQuestion(answerImage, questions)
             console.log('API 响应:', response)
             console.log('响应状态码:', response.code)
             console.log('响应数据:', response.data)
             console.log('响应消息:', response.msg)

             // 外部API可能没有code字段，只要有result字段就认为是成功的
             if (response.code === 1 || response.result) {
               // 即使后端返回judge为"error"，也认为是判断成功
               // 因为"error"表示判断过程成功完成，只是判断结果为"错误"
               console.log('API 调用成功，添加结果')
               results.push({
                 question: question,
                 result: response.result || response.data,
                 success: true
               })
             } else {
               console.log('API 调用失败，添加错误')
               results.push({
                 question: question,
                 error: response.msg || '判断失败',
                 success: false
               })
             }
           } catch (error) {
             console.log('API 调用异常:', error)
             results.push({
               question: question,
               error: '网络错误',
               success: false
             })
           }
         }

         this.batchJudging = false
         this.showBatchResults(results)
       } catch (error) {
         this.batchJudging = false
         console.error('批量判断答案时出错:', error)
         this.$message.error('批量判断失败，请重试')
       }
     },

     // 显示批量判断结果
     showBatchResults(results) {
       // 存储结果数据供查看按钮使用
       this.batchResults = results

       // 添加调试日志
       console.log('=== showBatchResults 调试信息 ===')
       console.log('完整的结果数组:', results)
       results.forEach((r, index) => {
         console.log(`第${index + 1}题结果:`, {
           success: r.success,
           hasResult: !!r.result,
           resultType: typeof r.result,
           resultKeys: r.result ? Object.keys(r.result) : '无result',
           error: r.error
         })
         if (r.result) {
           console.log(`第${index + 1}题result详情:`, r.result)
         }
       })

       // 计算判断成功的题目数量（包括judge为"error"的情况）
       const successCount = results.filter(r => r.success).length
       const totalCount = results.length

       // 计算实际正确的题目数量（judge为"correct"的题目）
       const correctCount = results.filter(r => {
         if (r.success && r.result && r.result.length > 0) {
           const firstResult = r.result[0]
           if (firstResult.results && firstResult.results.length > 0) {
             return firstResult.results[0].judge === 'correct'
           }
         }
         return false
       }).length

       this.resultTitle = `批量判断完成`
       this.resultMessage = `共 ${totalCount} 道题，判断成功 ${successCount} 道，实际正确 ${correctCount} 道，正确率 ${Math.round(correctCount / totalCount * 100)}%`

       if (successCount === totalCount) {
         this.resultIcon = 'el-icon-success'
         this.resultColor = '#67C23A'
       } else if (successCount > totalCount / 2) {
         this.resultIcon = 'el-icon-warning'
         this.resultColor = '#E6A23C'
       } else {
         this.resultIcon = 'el-icon-error'
         this.resultColor = '#F56C6C'
       }

       this.resultDialogVisible = true
       this.batchRedoDialogVisible = false

       // 重置选择状态
       this.selectAll = false
       this.isIndeterminate = false
       this.filteredQuestions.forEach(q => {
         q.selected = false
       })
     },

     // 显示详细结果
     showDetailedResults() {
       this.detailedResultsVisible = true
     },

     // 关闭详细结果对话框
     handleCloseDetailedResults() {
       this.detailedResultsVisible = false
     },

     // 获取学生答案
     getStudentAnswer(result) {
       if (result && result.length > 0) {
         const firstResult = result[0]
         if (firstResult.results && firstResult.results.length > 0) {
           return firstResult.results[0].student_answer || '无'
         }
       }
       return '无'
     },

     // 获取正确答案
     getCorrectAnswer(result) {
       if (result && result.length > 0) {
         const firstResult = result[0]
         if (firstResult.results && firstResult.results.length > 0) {
           return firstResult.results[0].answer || '无'
         }
       }
       return '无'
     },

     // 获取判断结果文本
     getJudgeText(result) {
       if (result && result.length > 0) {
         const firstResult = result[0]
         if (firstResult.results && firstResult.results.length > 0) {
           const judge = firstResult.results[0].judge
           if (judge === 'correct') return '正确'
           if (judge === 'error') return '错误'
           return String(judge)
         }
       }
       return '未知'
     },

     // 获取判断结果样式类
     getJudgeClass(result) {
       if (result && result.length > 0) {
         const firstResult = result[0]
         if (firstResult.results && firstResult.results.length > 0) {
           const judge = firstResult.results[0].judge
           return judge === 'correct' ? 'judge-correct' : judge === 'error' ? 'judge-error' : 'judge-unknown'
         }
       }
       return 'judge-unknown'
     },

     // 获取评语
     getComment(result) {
       console.log('=== getComment 调试信息 ===')
       console.log('传入的result参数:', result)

       // 根据后端数据结构，comment字段在 result[0].results[0].comment
       if (result && result.length > 0) {
         console.log('result存在，长度:', result.length)
         const firstResult = result[0]
         console.log('firstResult:', firstResult)

         if (firstResult.results && firstResult.results.length > 0) {
           console.log('firstResult.results存在，长度:', firstResult.results.length)
           const comment = firstResult.results[0].comment
           console.log('获取到的comment:', comment)
           return comment || ''
         } else {
           console.log('firstResult.results不存在或为空')
         }
       } else {
         console.log('result不存在或为空')
       }
       return ''
     },

     // 显示原始数据
     showRawData(result) {
       this.currentRawData = result.result
       this.rawDataVisible = true
     }
  }
}
</script>

<style scoped>
.detail-container {
  display: flex;
  padding: 32px;
  min-height: 80vh;
}
.sidebar {
  width: 180px;
  background: #f4f8fb;
  border-radius: 10px;
  padding: 24px 12px;
  margin-right: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sidebar-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: #409eff;
  margin-bottom: 18px;
}
.sidebar-select {
  width: 120px;
  margin-bottom: 16px;
}
.filter-section {
  width: 100%;
  margin-top: 16px;
}
.filter-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #606266;
  margin-bottom: 8px;
  text-align: center;
}
.main-content {
  flex: 1;
}

 /* 批量操作工具栏 */
 .batch-toolbar {
   background: #f8f9fa;
   border-radius: 8px;
   padding: 16px 20px;
   margin-bottom: 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border: 1px solid #e9ecef;
 }

 .batch-info {
   display: flex;
   align-items: center;
   gap: 16px;
 }

 .selected-count {
   color: #409eff;
   font-weight: 500;
   font-size: 0.9rem;
 }

 .batch-actions {
   display: flex;
   gap: 12px;
}
.question-list {
  width: 100%;
}
.question-row {
  display: flex;
  border-bottom: 1px solid #e0e7ef;
  padding: 18px 0;
   align-items: flex-start;
 }

 .question-checkbox {
   margin-right: 16px;
   margin-top: 4px;
}
.question-content {
  flex: 2;
  padding-right: 24px;
}
.question-title {
  color: #f56c6c;
  font-weight: 600;
  margin-bottom: 6px;
}
.question-body {
  color: #222;
  margin-bottom: 12px;
}
.question-actions {
  margin-top: 8px;
}
.redo-btn {
  margin-right: 8px;
}
.delete-btn {
  margin-left: 8px;
}
.question-reason {
  flex: 1;
  border-left: 2px solid #409eff;
  padding-left: 24px;
}
.reason-title {
  color: #409eff;
  font-weight: 600;
  margin-bottom: 6px;
}
.reason-body {
  color: #222;
  margin-bottom: 8px;
}
.question-time {
  font-size: 0.85rem;
  color: #909399;
  border-top: 1px solid #ebeef5;
  padding-top: 8px;
  margin-top: 8px;
}
.time-label {
  font-weight: 500;
  margin-right: 4px;
}
.time-value {
  color: #606266;
}

/* 重做对话框样式 */
.redo-content {
  padding: 20px 0;
}
.question-display {
  margin-bottom: 24px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
}
.question-display h4 {
  margin: 0 0 12px 0;
  color: #409eff;
}
.question-display p {
  margin: 0;
  line-height: 1.6;
  color: #333;
}
.upload-section {
  margin-top: 20px;
}
.upload-section h4 {
  margin: 0 0 12px 0;
  color: #409eff;
}

/* 结果对话框样式 */
.result-content {
  text-align: center;
  padding: 20px 0;
}
.result-icon {
  font-size: 48px;
  margin-bottom: 16px;
}
.result-text h3 {
  margin: 0 0 12px 0;
  font-size: 20px;
}
 .result-text p {
   margin: 0;
   color: #666;
   line-height: 1.6;
 }

 /* 批量重做对话框样式 */
 .batch-redo-content {
   padding: 20px 0;
 }

 .selected-questions {
   margin-bottom: 24px;
   padding: 16px;
   background: #f8f9fa;
   border-radius: 8px;
   border: 1px solid #e9ecef;
 }

 .selected-questions h4 {
   margin: 0 0 16px 0;
   color: #409eff;
   font-size: 16px;
 }

 .question-list-mini {
   max-height: 200px;
   overflow-y: auto;
 }

 .question-item-mini {
   display: flex;
   padding: 8px 0;
   border-bottom: 1px solid #e9ecef;
   align-items: flex-start;
 }

 .question-item-mini:last-child {
   border-bottom: none;
 }

 .question-number {
   color: #409eff;
   font-weight: 600;
   margin-right: 12px;
   min-width: 30px;
 }

 .question-content-mini {
   color: #333;
   line-height: 1.5;
   flex: 1;
 }

 .upload-tips {
   color: #909399;
   font-size: 0.9rem;
   margin: 8px 0 16px 0;
   line-height: 1.4;
 }

 .upload-demo {
   margin-top: 16px;
 }

 .upload-status {
   margin: 16px 0;
 }

 .upload-status .el-alert {
   margin-bottom: 16px;
 }

/* 详细结果对话框样式 */
.detailed-results-content {
  max-height: 600px;
  overflow-y: auto;
}

/* 表格题号样式 */
.question-number-badge {
  background: #409eff;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  display: inline-block;
  min-width: 50px;
  text-align: center;
}

/* 题目内容单元格样式 */
.question-content-cell {
  max-width: 200px;
  line-height: 1.4;
  word-break: break-word;
}

/* 状态样式 */
.status-success {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #67C23A;
  font-weight: 600;
}

.status-success i {
  margin-right: 4px;
}

.status-error {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #F56C6C;
  font-weight: 600;
}

.status-error i {
  margin-right: 4px;
}

/* 判断结果样式 */
.result-summary {
  padding: 8px 0;
}

.result-row {
  display: flex;
  margin-bottom: 6px;
  align-items: flex-start;
}

.result-row:last-child {
  margin-bottom: 0;
}

.result-label {
  font-weight: 600;
  color: #606266;
  min-width: 80px;
  margin-right: 8px;
  flex-shrink: 0;
}

.result-value {
  color: #333;
  flex: 1;
  word-break: break-word;
}

/* 判断结果状态样式 */
.judge-correct {
  color: #67C23A;
  font-weight: 600;
}

.judge-error {
  color: #F56C6C;
  font-weight: 600;
}

.judge-unknown {
  color: #909399;
  font-weight: 600;
}

/* 评语样式 */
.comment-text {
  color: #E6A23C;
  font-style: italic;
}

/* 评论显示样式 */
.comment-display {
  padding: 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  margin-bottom: 8px;
}

.comment-display .comment-text {
  color: #606266;
  font-style: normal;
  line-height: 1.5;
  word-break: break-word;
}

/* 查看原始数据按钮 */
.view-raw-btn {
  margin-top: 8px;
  color: #409eff;
}

/* 错误显示样式 */
.error-display {
  color: #F56C6C;
  font-weight: 500;
}

.error-text {
  background: #fef0f0;
  border: 1px solid #fbc4c4;
  border-radius: 4px;
  padding: 6px 10px;
  display: inline-block;
}

/* 原始数据对话框样式 */
.raw-data-content {
  max-height: 400px;
  overflow-y: auto;
}

.json-display {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 16px;
  margin: 0;
  font-family: 'Courier New', monospace;
  font-size: 0.85rem;
  line-height: 1.4;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
